exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".emoji[data-v-26ae324b]{vertical-align:top}.messageinput[data-v-26ae324b]{width:calc(100% - 110px);float:left!important;min-height:38px}.discuss-thread-container[data-v-26ae324b]{padding-bottom:25px;overflow:visible}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-26ae324b","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/discuss/discuss-singlethread-miniview.vue
// module id = 1184
// module chunks = 0